import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import type { AdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { PaywalledAdvisorAction } from '@src/components/sco/Advisors/shared/PaywalledAdvisorAction';
import { AdvisorMarketplaceAction, advisorMarketplaceActionHref } from '@src/components/sco/Advisors/utils/advisorMarketplaceActions';
import { NextLink } from '@src/components/sco/utilities/NextLink';
type AdvisorMarketplaceActionButtonProps = {
  action: AdvisorMarketplaceAction;
  userId: string;
  paths: Pick<AdvisorsPaths, 'sessionNew' | 'inbox' | 'profile' | 'withQuery'>;
  slug?: string | null;
  /** L18 `?ref=` for the Book link. */
  bookingRef?: string | null;
  onInvite?: () => void;
};

/** Directory / profile CTA. Message and Invite are gated behind the $49 `canAccessChat` paywall. */
export const AdvisorMarketplaceActionButton = t0 => {
  const $ = _c(17);
  const {
    action,
    userId,
    paths,
    slug,
    bookingRef,
    onInvite
  } = t0;
  let t1;
  if ($[0] !== action || $[1] !== bookingRef || $[2] !== paths || $[3] !== slug || $[4] !== userId) {
    t1 = advisorMarketplaceActionHref(action, userId, paths, slug, bookingRef);
    $[0] = action;
    $[1] = bookingRef;
    $[2] = paths;
    $[3] = slug;
    $[4] = userId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const href = t1;
  let t2;
  if ($[6] !== action.key || $[7] !== action.label || $[8] !== action.variant || $[9] !== href || $[10] !== onInvite) {
    t2 = href ? <Button asChild={true} size="sm" variant={action.variant} width="full" onClick={_temp}><NextLink href={href}>{action.label}</NextLink></Button> : action.key === "invite" ? <Button size="sm" variant={action.variant} width="full" onClick={event_0 => {
      event_0.stopPropagation();
      onInvite?.();
    }}>{action.label}</Button> : null;
    $[6] = action.key;
    $[7] = action.label;
    $[8] = action.variant;
    $[9] = href;
    $[10] = onInvite;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const button = t2;
  if (action.key === "message" || action.key === "invite") {
    const t3 = action.key === "invite" ? "advisor-invite" : "advisor-message";
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        size: "sm",
        width: "full",
        onClick: _temp2
      };
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const t5 = action.key === "invite" ? "Upgrade to Invite" : "Upgrade to Message";
    let t6;
    if ($[13] !== button || $[14] !== t3 || $[15] !== t5) {
      t6 = <PaywalledAdvisorAction intent={t3} upgradeCtaButtonProps={t4} upgradeCtaLabel={t5}>{button}</PaywalledAdvisorAction>;
      $[13] = button;
      $[14] = t3;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  return button;
};
function _temp(event) {
  return event.stopPropagation();
}
function _temp2(event_1) {
  return event_1.stopPropagation();
}